import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'app/shared/i18n';

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="ms-footer">
      <div className="ms-footer__inner">
        <div className="ms-footer__brand">
          <div
            style={{
              width: 28,
              height: 28,
              borderRadius: 8,
              background: 'linear-gradient(135deg, #F59E0B 0%, #F97316 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 14,
              fontWeight: 800,
              color: '#000',
            }}
          >
            M
          </div>
          <span>&copy; 2025 MailsNgon. {t('footer.copyright')}</span>
        </div>
        <div className="ms-footer__links">
          <Link to="/terms-of-service">{t('footer.terms')}</Link>
          <Link to="/policy">{t('footer.privacy')}</Link>
          <a href="https://t.me/mailsngon" target="_blank" rel="noreferrer">
            Telegram ↗
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
